import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SendIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m18.29 1.62-9.17 9.17m9.17-9.17-5.83 16.67-3.34-7.5-7.5-3.33 16.67-5.84Z"
      />
    </Icon>
  );
}
